<script setup lang="ts">
import type { AggregationEntry } from '~/models/Content/Response'
import { useAppColor } from '~/composables/useAppColor'
import Button from '~/components/ui/Button.vue'

const props = defineProps<{
  entry?: Partial<AggregationEntry>
  name: string
}>()

const { themeColor } = useAppColor()
</script>

<template>
  <Button
    variant="ghost"
    full-width
    :color="themeColor ?? 'brand'"
  >
    <slot />
    <div class="flex w-full justify-between">
      <span
        class="first-letter:capitalize"
        v-text="props.name"
      />
      <span
        v-if="props.entry"
        class="text-gray-40 font-normal"
        v-text="props.entry.count"
      />
    </div>
  </Button>
</template>
